import React from "react";
import styles from "./index.module.scss";
import { useDevice } from "@/hooks/useDevice";
import LazyMedia from "@/components/LazyMedia";
import { IBanner } from "@/common/types";

interface ISoftware{
  banners: IBanner[];
  words: Record<string, string>;
}

const Banner:React.FC<ISoftware> = ({banners}) => {
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  const banner = banners[0] ?? null // banner数据

    return (
      <>
      {banner && (
        <div className={styles.banner}>
          <div className={styles.softBanner}>
            <>
              {
                banner[newDevice].extension === '.mp4'
                ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url} className={styles.bannerImg}></LazyMedia>
                : <LazyMedia type="image" src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} className={styles.bannerImg} />
              }
            </>
            <div className={styles.bannerText}>
              {banner?.isShowTitle === 1 && (
                <p className={styles.textTittle}>{banner?.name}</p>
              )}
              <p className={styles.textContent}>{banner?.briefIntroduction}</p>
            </div>
          </div>
        </div>
      )}
      </>
    );
  };
  export default Banner;
